import { render, staticRenderFns } from "./newStockTransfer.vue?vue&type=template&id=505820cc&"
import script from "./newStockTransfer.vue?vue&type=script&lang=js&"
export * from "./newStockTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports